import React from 'react';
import AdminUsers from 'src/components/AdminUsers';
import ResponsiveWrapper from 'src/components/ResponsiveWrapper';

const ProxyUsers = () => {
    return (
        <ResponsiveWrapper>
            <AdminUsers />
        </ResponsiveWrapper>
    );
};

export default ProxyUsers;
